import { render, staticRenderFns } from "./PublicChats.vue?vue&type=template&id=59c70965&scoped=true&"
import script from "./PublicChats.vue?vue&type=script&lang=js&"
export * from "./PublicChats.vue?vue&type=script&lang=js&"
import style0 from "./PublicChats.vue?vue&type=style&index=0&id=59c70965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c70965",
  null
  
)

export default component.exports